import { Reveal, Eyebrow } from "./Reveal";
import GlobeCanvas from "./GlobeCanvas";

export default function GlobalSection() {
    return (
        <section
            id="global"
            data-testid="global-reach-section"
            className="relative overflow-hidden bg-base py-28 lg:py-40"
        >
            <div className="absolute inset-0">
                <GlobeCanvas />
            </div>
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_55%_55%_at_50%_50%,rgba(5,7,12,0.82),rgba(5,7,12,0.35)_65%,rgba(5,7,12,0.9))]" />
            <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-void to-transparent" />
            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-void to-transparent" />

            <div className="relative z-10 mx-auto max-w-4xl px-5 text-center sm:px-8">
                <Reveal>
                    <Eyebrow className="justify-center">Global Presence</Eyebrow>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2 className="font-grotesk text-2xl font-bold uppercase leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl">
                        Built for a <span className="text-grad-blue">borderless digital economy.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.14}>
                    <p className="mx-auto mt-6 max-w-lg text-base leading-relaxed text-slate-400">
                        TAVONX is designed for a new generation of users participating in
                        global digital markets.
                    </p>
                </Reveal>

                <Reveal delay={0.2}>
                    <div data-testid="global-brand-line" className="mt-14 font-grotesk font-bold uppercase">
                        <div className="text-xl tracking-[0.14em] text-white sm:text-2xl lg:text-3xl">
                            Global markets.
                        </div>
                        <div className="mt-2 text-xl tracking-[0.14em] text-white sm:text-2xl lg:text-3xl">
                            Borderless opportunities.
                        </div>
                        <div className="text-grad-blue mt-2 text-xl tracking-[0.14em] sm:text-2xl lg:text-3xl">
                            A brighter financial tomorrow.
                        </div>
                    </div>
                </Reveal>

                <Reveal delay={0.28}>
                    <div className="mt-14 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                        {["New York", "London", "Frankfurt", "Dubai", "Singapore", "Tokyo"].map((c) => (
                            <span key={c} className="flex items-center gap-2">
                                <span className="h-1 w-1 rounded-full bg-cyber/70" />
                                {c}
                            </span>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
